<template>
    <div class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div v-if="step === 0">
                        <div>
                            <div class="alert alert-warning" v-html="$t('<b>You are registering for the English class.</b> If you wish to register for the Spanish class, select <b>Español</b> from the language drop-down menu on the top bar of the page.')"></div>

                            <div class="form-group">
                                <button type="button" class="btn btn-default" @click="next($event)">{{$t('I wish to continue registering for the English class')}}</button>
                            </div>
                            <button type="button" class="btn btn-default" data-dismiss="modal">{{$t('Please remove the English class from my cart; I will register for a Spanish class')}}</button>
                        </div>
                        <hr/>
                        <div style="margin-top:20px">
                            <div class="alert alert-warning" v-html="$t('<b>¡Esta es la página de inscripción para cursos en inglés!</b> Para inscribirse a cursos en español, seleccione <b>Español</b> en la lista desplegable de idioma en la barra superior de la página.')"></div>

                            <div class="form-group">
                                <button type="button" class="btn btn-default" @click="next($event)">{{$t('Deseo inscribirme a la clase en Inglés')}}</button>
                            </div>
                            <button type="button" class="btn btn-default" data-dismiss="modal">{{$t('Favor de remover la clase en Inglés de mi carrito de compra; Me voy a inscribir a la clase en Español')}}</button>
                        </div>
                    </div>
                    <div v-if="step === 1">
                        <div class="checkbox">
                            <div class="pl20">
                                <input id="checkViewedPractDocs" type="checkbox" v-model="viewedPracticumDocs" v-bind:true-value="true" v-bind:false-value="false" /> 
                                <label for="checkViewedPractDocs" :class="{'pl0': true, 'text-danger': step1Submitted && !viewedPracticumDocs}">{{$t('I have viewed the practicum documents')}}</label> 
                                <a href="https://artioscollege.org/practicum/" rel="noopener noreferrer" target="_blank"> {{$t('here')}} </a>
                                <label for="checkViewedPractDocs" :class="{'pl0': true, 'text-danger': step1Submitted && !viewedPracticumDocs}">{{$t('and understand the format and requirements for the practicum.')}}</label>
                            </div>
                        </div>
                        <div class="checkbox">
                            <b><label :class="{'text-danger': step1Submitted && !madeArrangementsFieldAdv}"><input type="checkbox" v-model="madeArrangementsFieldAdv" v-bind:true-value="true" v-bind:false-value="false" /> {{$t('I made/am making arrangements with a Field Advisor who will oversee my ministry hours.')}}</label></b>
                        </div>
                        <div class="form-group">
                            <label :class="{'text-danger': step1Submitted && !fieldAdvisor}">{{$t('My field advisor will be:')}}</label>
                            <input type="text" class="form-control" v-model="fieldAdvisor" />
                        </div>
                    </div>
                    <div v-if="step === 2">
                        <em>
                            {{ $t('Please check textbook availability in your country before you register for a course! To see which books you’ll need,')}} <a href="/textbooks" target="_blank" @click="onClickedTextbookLink()" class="textbook-popover">{{$t('click here.')}}</a><br/>
                            <small><br/>{{ $t('Please note, the list of recommended vendors is relevant only for students who reside within the United States. If you cannot find these textbooks in your country, be prepared to pay extra shipping if you order them from vendors in the United States. You will need your textbooks before the start date of each course.')}}</small>
                        </em>
                        <br/>
                        <div class="checkbox">
                            <b><label :class="{'text-danger': step2Submitted && !agreeTextbook}"><input type="checkbox" v-model="agreeTextbook" v-bind:true-value="true" v-bind:false-value="false" /> {{$t('I have ordered my textbooks and will receive them before the class begins!')}}</label></b>
                        </div>
                    </div>
                    <div v-if="step === 3">
                        <div class="form-group">
                            <label>{{$t('Did someone refer you to this class?')}}</label>
                            <select v-model="options.referral" class="form-control">
                                <option value=""></option>
                                <option :value="true">{{$t('Yes')}}</option>
                                <option :value="false">{{$t('No one referred me to this class')}}</option>
                            </select>
                        </div>
                        <div v-if="options.referral">
                            <h4>{{$t('Please tell us who')}}</h4>
                            <div class="form-group">
                                <label>{{$t('Name')}}</label>
                                <input type="text" class="form-control" v-model="options.referral_name" />
                            </div>
                            <div class="form-group">
                                <label>{{$t('Email Address')}}</label>
                                <input type="text" class="form-control" v-model="options.referral_email" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" v-if="step > 0">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" @click="next($event)">Next</button>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</template>

<script>
    export default {
        props: {
            item: {required: true},
        },
        data() {
            return {
                step: 0,
                international: false,
                clickedTextbookLink: false,
                clickedPracticumDocLink: false,
                agreeTextbook: false,
                viewedPracticumDocs: false,
                madeArrangementsFieldAdv: false,
                fieldAdvisor: '',
                step1Submitted: false,
                step2Submitted: false,
                options: {
                    referral: '',
                    referral_name: '',
                    referral_email: '',
                }
            }
        },
        methods: {
            refresh() {
                this.$http.get('/api/cart/show-course-options').then(response => {
                    this.international = response.data.international;
                })
            },
            onClickedTextbookLink() {
                this.clickedTextbookLink = true;
                $('.textbook-popover').popover('destroy');
            },
            onClickedPracticumDocLink() {
                this.clickedPracticumDocLink = true;
                $('.practicum-popover').popover('destroy');
            },
            next(event) {
                let done = true;

                if(this.step === 1) {
                    if(this.clickedPracticumDocLink === false)
                    {
                        $('.practicum-popover').popover({content: this.$t('You must click this link before you can continue'), placement: 'bottom', trigger: 'manual'});
                        $('.practicum-popover').popover('show');
                        done = false;
                    }
                    if(!this.viewedPracticumDocs || !this.madeArrangementsFieldAdv || this.fieldAdvisor.length === 0)
                    {
                        done = false;
                    }
                    this.step1Submitted = true;
                }

                if(this.step === 2)
                {
                    if(this.clickedTextbookLink === false)
                    {
                        $('.textbook-popover').popover({content: this.$t('You must click this link before you can continue'), placement: 'bottom', trigger: 'manual'});
                        $('.textbook-popover').popover('show');
                        done = false;
                    }

                    if(this.agreeTextbook === false)
                    {
                        done = false;
                    }
                    this.step2Submitted = true;
                }

                event.preventDefault();
                event.stopPropagation();

                if(done)
                {
                    if(this.step === 3)
                    {
                        this.$http.post('/api/cart', {item: this.item, options: this.options}).then(response => {
                            $(this.$el).modal('hide');
                            this.$root.bus.$emit('cart:refresh');
                            //added error catching here for courses.  TODO: Make fully parallel with process in Cart.vue
                            if(!response.data.success){
                                this.$alert(null, {
                                    title: this.$t("Alert"),
                                    message: response.data.error,
                                    confirm: this.$t("I Understand"),
                                });
                            }
                        })
                    }
                    else if(this.step === 0 && this.item.number !== "491") // 491 represents a practicum course.
                       this.step = 1; // Skip step 1
    
                    if(this.step === 1 && !this.international)
                        this.step = 3; // Skip step 2
                    else if( this.step < 3 )
                        this.step++;
                }
            }
        },
        mounted() {
            this.refresh();
        }
    }
</script>
